import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter } from 'react-router-dom';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={'/alojamiento-temporal'}>
        <SkeletonTheme 
          baseColor="#f8f9fa" 
          highlightColor="#fff7e9"
          borderRadius="8px"
          duration={1.5}
        >
          <App />
        </SkeletonTheme>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

serviceWorker.unregister();
